import React from 'react';

const CuiBanner = () => (
  <div className='cui-banner row no-gutters'>
    <b>Highest Possible Classification is CUI</b>
  </div>
);

export default CuiBanner;
